<template>
    <div  :style='{width: panelWidth}' >
<!--
    <table width='100%' class='table' v-if='data && data.length'>
      <tr>
        <th width='30%' class='colTitle'>{{ $t(label) }}</th>
        <th width='20%' v-if='typeLots === "mios"' class='colTitle'>{{ $t("Exposure") }}</th>
        <th width='20%' v-if='typeLots === "lots"' class='colTitle'>{{ $t("Lots") }}</th>
        <th width='25%' v-if='isSymbolGrpKey' class='colTitle'>{{ $t("VWAP") }}</th>
        <th width='25%' v-if='isSymbolGrpKey' class='colTitle'>{{ $t("Current") }}</th>
      </tr>
      <tr class='lu-click' v-for='(ins, index) in data' :key='ins.instrumentName' v-if='index < count' @dblclick='getDetail(ins.label)'>
        <td lu-flex class='rowTitle'>{{ ins.label }}</td>
        <td class='rowData' v-if='typeLots === "mios"' :class='ins.exposure >= 0  ? "positive" : "negative"'>{{ ins.exposure | formatAmount }}</td>
        <td class='rowData' v-if='typeLots === "lots"' :class='ins.numberOfLot >= 0  ? "positive" : "negative"'>{{ ins.numberOfLot | formatAmount }}</td>
        <td class='rowData' v-if='isSymbolGrpKey'>{{ ins.vwap | formatRate(6) }}</td>
        <td class='rowData' v-if='isSymbolGrpKey'>{{ ins.best | formatRate(5) }}</td>
      </tr>
    </table>
    -->

  <el-table
      class='riskTable'
      :data="data"
      :cell-class-name = "() => 'lu-click'"
      :height="panelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.label)'
    >
      <el-table-column :label="$t(label)" sortable prop='label'  align="left" />
      <el-table-column :label="$t('Exposure')" sortable prop='exposure' :sort-method='(a,b) => sortFloat(a,b,"exposure")' align="left" v-if='typeLots === "mios"'>
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.exposure >= 0  ? "positive" : "negative"'>{{ scope.row.exposure | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Lots')" sortable prop='numberOfLot' :sort-method='(a,b) => sortFloat(a,b,"numberOfLot")' align="center" v-if='typeLots === "lots"'>
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.numberOfLot >= 0  ? "positive" : "negative"'>{{ scope.row.numberOfLot | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('PnL')" sortable :sort-method='(a,b) => sortFloat(a,b,"profitAndLoss")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.profitAndLoss >= 0  ? "positive" : "negative"'>{{ scope.row.profitAndLoss | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('VWAP')" sortable :sort-method='(a,b) => sortFloat(a,b,"vwap")' align="center" v-if='isSymbolGrpKey' >
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.vwap | formatRate(6) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Current')" sortable :sort-method='(a,b) => sortFloat(a,b,"best")' align="center" v-if='isSymbolGrpKey' >
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.best | formatRate(5) }}</div>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
// import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import { mapState } from 'vuex'
import monitoringMixin from './mixins'

export default {
  name: 'InstrExpArray',
  props: [ 'data', 'label', 'panel' ],
  mixins: [ monitoringMixin ],
  // components: {LuScrollArea, LuHbox, LuVbox, LuItem},
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value || 0, 2, 3)
    },
    formatRate: function (value, prec) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec)
    }
  },
  computed: {
    ...mapState({ groupKeys: state => state.settingsMonitor.settingParams.changeGrouping, panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    isSymbolGrpKey: function () {
      return this.groupKeys[this.panel.options.groupKey] === "symbol"
    },
    typeLots: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return tmp ? tmp.options.lotsMios : 'mios'
    }
  },
  methods: {
    getDetail: function (label) {
      let curLabel = this.isSymbolGrpKey ? 'symbol' : 'currency'
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': curLabel, 'paramValue': label}
      ]
      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
      this.$emit('getDetail', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
    }
  },
  data: function () {
    return {
      lots: false
    }
  }
}
</script>

<style lang='scss' scoped>
.inst-container {
  .rowData {
    justify-content: center;
    vertical-align: baseline;
    height: 25px;
    margin: 5px 0;
  }
}
</style>